import { User } from './User';
import type { UserWithPermissions } from '@/shared/api';

const DEFAULT_TECHNICIAN_COLOR = '#2196F3';

export class Technician extends User {
  readonly color: string;
  readonly isActive: boolean;

  constructor(data: UserWithPermissions) {
    super(data);
    this.color = data.color ?? DEFAULT_TECHNICIAN_COLOR;
    this.isActive = data.isActive ?? false;
  }
}
